import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-after-logout',
  template: ``,
})
export class AfterLogoutComponent implements OnInit {
  ngOnInit(): void {
    const host = window.location.origin;

    window.location.href = `https://login.microsoftonline.com/11ff3d4c-fb78-4062-8c0a-3bc519276271/oauth2/v2.0/logout?post_logout_redirect_uri=${host}`;
  }
}
